<template>
  <mdb-container class="gp-has-header">
    <h4 class="text-left">
      <mdb-icon color="primary" icon="envelope"/>
      Private Messages
    </h4>
    <div v-if="showList">
      <mdb-input @input="isTyping = true"
                 placeholder="Find a Message" type="text" v-model="conversationQuery"
      />
      <div class="text-left" v-if="messages.length ==0">No messages.</div>
      <div class="text-left">
        <mdb-btn @click="showNewMessage=true" icon="comment-plus">New Message</mdb-btn>
        <mdb-btn v-if="anySelected" @click="showDeleteSelectedConfirm = true" icon="house-leave" color="danger">Leave
          Selected
        </mdb-btn>
      </div>
      <mdb-tbl class="text-left" responsive striped v-if="messages.length>0">
        <mdb-tbl-head class="primary-color text-white">
          <tr>
            <th>&nbsp;</th>
            <th>Who</th>
            <th>Last Activity</th>
            <th>Subject</th>
            <th>&nbsp;</th>
          </tr>
        </mdb-tbl-head>
        <mdb-tbl-body>
          <tr :key="m.id" v-for="m in messages">
            <td>
              <mdb-input :id="'checkbox-'+m.id" v-model="m.selected" type="checkbox"/>
            </td>
            <td @click="viewMessage(m)" class="clickable">{{ m.participantLabel }}</td>
            <td>{{ m.lastActivity }}</td>
            <td @click="viewMessage(m)" class="clickable">{{ m.subject }}</td>
            <th>
              <mdb-icon color="danger" fal icon="envelope" v-if="m.isNew"></mdb-icon>
              <mdb-icon color="success" fal icon="envelope-open" v-if="!m.isNew"></mdb-icon>
            </th>
          </tr>
        </mdb-tbl-body>
      </mdb-tbl>
      <div v-if="totalMessages == messages.length">
        <h6>All messages displayed.</h6>
      </div>
    </div>
    <div v-if="showMessage">
      <h3 class="text-left">
        <mdb-btn @click="inbox" icon="arrow-left" size="sm">Back to In Box</mdb-btn>
        Subject: {{ currentMessage.subject }}

      </h3>
      <mdb-card class="mb-4">
        <mdb-card-header>
          Participants
        </mdb-card-header>
        <mdb-card-body>
          <div>
            <span :key="p.id" v-for="p in currentMessage.participants">
              <mdb-chip :src="p.avatar" size="sm">{{ p.name }} <a href="" v-if="p.mayRemove"
                                                                  @click.prevent="removeParticipant(p)">
                <mdb-icon color="danger" icon="user-slash"></mdb-icon>
              </a></mdb-chip>

            </span>
          </div>
          <mdb-btn v-if="!currentMessage.blocked" @click="addParticipants = true" color="warning" icon="user-plus"
                   size="sm">Add Participants
          </mdb-btn>
          <mdb-btn @click="leaveModal = true" color="danger" icon="house-leave" size="sm">Leave Conversation</mdb-btn>
        </mdb-card-body>

      </mdb-card>

      <messaging :allowReply="false"
                 :blocked="currentMessage.blocked"
                 :id="currentMessage.id"
                 :labels="{type:'Message', pluralType:'Messages'}"
                 type="conversation"
                 v-if="showMessage && currentMessage"
      />
    </div>
    <mdb-modal size="lg" v-if="showNewMessage">
      <mdb-modal-header class="primary-color text-white text-center">
        <h5>New Private Message</h5>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-input @input="isTyping = true"
                   @keydown.native="handleKeyDown"
                   placeholder="Add a recipient" type="text" v-model="query"
        />
        <mdb-row v-if="foundUsers.length>0">
          <mdb-col col="12">
            <h6>Select One:</h6>

            <span :class="{'mb-4': true, clickable: true}" :key="u.id" @click="pickUser(u)" v-for="(u,i) in foundUsers">
              <mdb-chip :color="i==selectIndex ? 'success-color' : '' " :src="u.profilePic"
                        :text="i==selectIndex ? 'white' : ''"
                        size="sm" waves>{{ u.name }}
              </mdb-chip>
            </span>
          </mdb-col>

        </mdb-row>
        <div class="text-left" v-if="recipients.length > 0 ">
          <h4>Recipients:</h4>
          <span :key="r.id" v-for="r in recipients">
            <mdb-chip :alt="r.name" :src="r.profilePic" @closeChip="removeRecipient(r)" close size="sm" waves>
              {{ r.name }}
            </mdb-chip>
          </span>
        </div>
        <mdb-input label="Subject" type="text" v-model="subject"/>

        <editor ref="editor" :init="editorConfig" v-model="text"/>

        <mdb-btn :disabled="!text || !subject || recipients.length==0" @click="send" icon="envelope">Send</mdb-btn>
        <mdb-btn @click="cancelNewMessage" color="danger" icon="times-circle">Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal @close="addParticipants = false" size="lg" v-if="addParticipants">
      <mdb-modal-header :close="true" class="primary-color text-white text-center">
        <h5>Add Participant(s)</h5>
      </mdb-modal-header>
      <mdb-modal-body>
        <div class="text-warning">
          Warning - adding participants will let them join the current conversation, but also see the history.
        </div>

        <mdb-input @input="isTyping = true"
                   @keydown.native="handleKeyDown"
                   placeholder="Add a recipient" type="text" v-model="query"
        />
        <mdb-row v-if="foundUsers.length>0">
          <mdb-col col="12">
            <h6>Select One:</h6>
            <span :class="{'mb-4': true, clickable: true}" :key="u.id" @click="pickUser(u)" v-for="(u,i) in foundUsers">
              <mdb-chip :color="i==selectIndex ? 'success-color' : '' " :src="u.profilePic"
                        :text="i==selectIndex ? 'white' : ''"
                        size="sm" waves>{{ u.name }}
              </mdb-chip>
            </span>
          </mdb-col>

        </mdb-row>
        <div class="text-left" v-if="recipients.length > 0 ">
          <h4>Recipients:</h4>
          <span :key="r.id" v-for="r in recipients">
            <mdb-chip :alt="r.name" :src="r.profilePic" @closeChip="removeRecipient(r)" close size="sm" waves>
              {{ r.name }}
            </mdb-chip>
          </span>
        </div>
        <mdb-btn :disabled="recipients.length==0" @click="addRecipients" icon="user-plus">Add</mdb-btn>
        <mdb-btn @click="addParticipants = false" color="danger" icon="times-circle">Cancel</mdb-btn>

      </mdb-modal-body>
    </mdb-modal>

    <yes-no-modal @no="showDeleteSelectedConfirm = false"
                  @yes="leaveSelected"
                  additional-text="You will no longer be able to view any conversation you leave. In addition, if you are the last person in the conversation, it will be removed completely."
                  v-if="showDeleteSelectedConfirm"/>

    <yes-no-modal @no="leaveModal = false"
                  @yes="leaveConfirmed"
                  question="Are you sure? Once you leave, you will no longer be able to participate or see history."
                  v-if="leaveModal"/>

    <yes-no-modal @no="showRemoveParticipantModal = false"
                  @yes="doRemoveParticipant"
                  question="Are you sure you wish to remove this participant?"
                  additional-text="Once they are removed, their conversation history will remain, but they will no longer have access to this conversation."
                  v-if="showRemoveParticipantModal"/>

  </mdb-container>
</template>

<script>
import api from '../services/groupsPlaceApi'
import yesNoModal from "./common/YesNoModal";
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbChip,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbMasonry,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbRow,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';
import messaging from "./common/Messaging";
import avatar from "./common/Avatar";
import _ from 'lodash'
import editor from '@tinymce/tinymce-vue'
import editorSettings from "../services/editorSettings";
import messageCreate from "./common/MessageCreate.vue";

export default {
  name: 'Conversation',
  components: {
    messageCreate,
    mdbBtn,
    mdbContainer,
    mdbIcon,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    mdbChip,
    mdbMasonry,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbRow,
    mdbCol,
    mdbInput,
    messaging,
    avatar,
    yesNoModal,
    editor
  },
  computed: {
    anySelected() {
      for (let m of this.messages) {
        if (m.selected) return true
      }
      return false
    }
  },
  data() {
    return {
      messages: [],
      totalMessages: 0,
      showDeleteConfirm: false,
      showDeleteSelectedConfirm: false,
      showRemoveParticipantModal: false,
      deleteCandidate: null,
      deleteType: "",
      showNewMessage: false,
      recipients: [],
      query: "",
      conversationQuery: "",
      scrollEvent: null,
      showList: true,
      showMessage: false,
      currentMessage: null,
      isTyping: false,
      subject: "",
      foundUsers: [],
      selectedUser: null,
      text: "",
      selectIndex: -1,
      leaveModal: false,
      addParticipants: false,
      pastedImages: [],
      editorConfig: {
        browser_spellcheck: true,
        branding: false,
        plugins: ["image", "link", "code", "paste", "table", "lists"],
        images_upload_handler: this.handlePastedImage,
        toolbar: "undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link image",
        image_advtab: true,
        style_formats_merge: true,
        image_class_list: editorSettings.imageClassList(),
        formats: editorSettings.formats(),
        style_formats: editorSettings.styleFormats(),
        paste_as_text: true,
        paste_data_images: true,
        relative_urls: false,
        remove_script_host: false,
        height: 400,
        table_default_attributes: {
          class: "table table-responsive table-bordered table-striped table-hover",
          style: ""
        }
      }
    }
  },
  watch: {
    query: _.debounce(function () {
      this.isTyping = false;
    }, 300),
    isTyping: function (value) {
      if (!value) {
        if (this.query) this.lookupUser()
        else this.loadMessages()
      }
    },
    conversationQuery: _.debounce(function () {
      this.isTyping = false;
    }, 300)

  },
  async mounted() {
    //cache people user is allowed to communicate with
    api.get("/conversation/updateContactCache/").then(
      () => {
        console.log("Contact cache updated.")
      },
      (error) => {
        log.error("Could not update contact cache.", error.data)
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })

    if (this.$route.query.start) {
      let allowed = await this.validateUser(this.$route.query.start)
      if (allowed) {
        this.recipients.push(allowed)
        this.showNewMessage = true
      } else this.$notify.error({
                                  message: "You are not authorized to start a conversation with that person.",
                                  timeOut: 5000
                                })
    }

    if (this.$route.params.id) {
      this.$store.dispatch("setExecuting", true)
      api.get("/conversation/getOne/" + this.$route.params.id).then(
        (results) => {
          this.viewMessage(results.data)
        },
        (error) => {
          if (error.response.status == 403 || error.response.status == 401) this.$router.push("/403")
          else this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    } else {
      this.loadMessages(false)
    }
    window.addEventListener("scroll", this.scrollListener)
    document.title = "Private Messages";
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollListener)
  }
  ,
  methods: {
    handlePastedImage: async function (blobInfo, success, failure, progress) {
      const reduce = require('image-blob-reduce')();
      this.$store.dispatch("setExecuting", true)
      let image = blobInfo.blob()
      if (image.size >= 1000000) {
        await reduce.toBlob(image, {max: 1000})
          .then(blob => {
            image.file = blob
          })
      }

      let results = await api.generalUploadImage(null, null, image)

      if (results.success) {
        success(results.image.url)
        this.pastedImages.push(results.image.id)
        const editor = this.$refs.editor.editor;
        setTimeout( () => {
          const imgs = editor.dom.select('img[src="' + results.image.url + '"]');
          console.log("After ", imgs)
          if (imgs.length > 0) {
            editor.dom.setStyles(imgs[0], {'width': "33%"})
            editor.dom.addClass(imgs[0], "gp-user-image-left")
          }
        }, 200);
      }
      else {
        failure(results.message, {remove: true})
      }
      this.$store.dispatch("setExecuting", false)

    },
    async validateUser(id) {
      this.$store.dispatch("setExecuting", false)
      let allowed = null
      await api.get("/conversation/validateUser/" + id).then(
        (results) => {
          allowed = results.data
        },
        (error) => {
          if (error.response.status == 403 || error.response.status == 401) {
            this.$router.push({
                                path: '/403',
                                query: {redirect: this.$route.fullPath}
                              })
          } else {
            allowed = false
          }

        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
      return allowed
    },
    doRemoveParticipant() {
      this.showRemoveParticipantModal = false
      this.$store.dispatch("setExecuting", true)
      api.post('/conversation/removeParticipant/' + this.currentMessage.id, {participant: this.deleteCandidate.id}).then(
        (results) => {
          let loc = this.currentMessage.participants.indexOf(this.deleteCandidate)
          this.currentMessage.participants.splice(loc, 1)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      });
    },
    removeParticipant(p) {
      this.deleteCandidate = p
      this.showRemoveParticipantModal = true
    },
    removeRecipient(r) {
      let loc = this.recipients.indexOf(r)
      this.recipients.splice(loc, 1)
    },
    cancelNewMessage() {
      this.showNewMessage = false
      this.subject = ""
      this.recipients = []
      this.text = ""
    },
    send() {
      this.showNewMessage = false
      this.$store.dispatch("setExecuting", true);
      let payload = {subject: this.subject, recipients: this.recipients,
        messageText: this.text, pastedImages: this.pastedImages}
      api.post('/conversation/create', payload).then(
        (results) => {
          this.messages.unshift(results.data)
          this.subject = ""
          this.recipients = []
          this.text = ""
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
          this.showNewMessage = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      });
    }
    ,
    addRecipients() {
      this.addParticipants = false
      this.$store.dispatch("setExecuting", true);
      let payload = {recipients: this.recipients}
      api.post('/conversation/addRecipients/' + this.currentMessage.id, payload).then(
        (results) => {
          for (let i = 0; i < this.recipients.length; i++) {
            let r = this.recipients[i]
            this.currentMessage.participants.push({name: r.name, avatar: r.profilePic, id: r.id})
          }
          this.recipients = []
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
          this.addParticipants = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      });
    }
    ,
    lookupUser() {
      this.foundUsers = []
      if (!this.query) {
        return
      }
      api.get("/conversation/findUser?term=" + this.query).then(
        (results) => {
          for (let i = 0; i < results.data.length; i++) {
            this.foundUsers = results.data
            this.selectIndex = 0
          }
        },
        (error) => {

        })
    }
    ,
    handleKeyDown(e) {
      if (this.foundUsers.length == 0) return
      let watchKeys = [37, 40, 39, 38, 13]
      if (watchKeys.indexOf(e.keyCode) === -1) return
      if (e.keyCode == 40 || e.keyCode == 39) { /*down or right*/
        this.selectIndex++
        if (this.selectIndex > (this.foundUsers.length - 1)) this.selectIndex = 0
      }
      if (e.keyCode == 38 || e.keyCode == 37) { /*up or left*/
        this.selectIndex--
        if (this.selectIndex < 0) this.selectIndex = this.foundUsers.length - 1
      }
      if (e.keyCode == 13) this.pickUser(this.foundUsers[this.selectIndex])
    }
    ,
    async pickUser(u) {
      let allowed = await this.validateUser(u.id)
      if (allowed) {
        this.recipients.push(u)
        this.foundUsers = []
        this.selectIndex = -1
        this.query = ""
      } else this.$notify.error({
                                  message: "You are not authorized to start a conversation with that person.",
                                  timeOut: 5000
                                })
    }
    ,
    scrollListener() {
      if (!this.showList) return
      let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
      if (bottomOfWindow && this.totalMessages > this.messages.length) this.loadMessages(true)
    },
    loadMessages: function (loadMore) {
      let offset = 0
      if (!loadMore) this.messages = []
      else {
        offset = this.messages.length
        if (offset == this.totalMessages) return
      }
      this.$store.dispatch("setExecuting", true)
      let url = "/conversation/get?offset=" + offset
      if (this.conversationQuery) url += "&term=" + this.conversationQuery
      api.get(url).then(
        (results) => {
          if (loadMore) {
            for (let i = 0; i < results.data.messages.length; i++) {
              this.messages.push(results.data.messages[i])
            }
          } else this.messages = results.data.messages
          this.totalMessages = results.data.totalCount
        },
        (error) => {
          if (error.response.status == 403 || error.response.status == 401) this.$router.push("/403")
          else this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
    ,
    refresh: function () {
      this.loadMessages(false)
    }
    ,
    viewMessage: function (m) {
      this.currentMessage = m
      this.showList = false
      this.showMessage = true
      if (m.isNew) {
        api.get("/conversation/updateActivity/" + m.id).then(
          (results) => {
            m.isNew = false
          },
          (error) => {

          })
      }
    },
    leaveSelected: function () {
      this.showDeleteSelectedConfirm = false
      this.$store.dispatch("setExecuting", true)
      let payload = []
      for (let m of this.messages) {
        if (m.selected) payload.push(m.id)
      }
      api.post("/conversation/leaveMultiple", {conversations: payload}).then(
        (results) => {
          for (let i of payload) {
            let loc = -1
            for (let j = 0; j < this.messages.length; j++) {
              let m = this.messages[j]
              if (m.id == i) loc = j
            }
            if (loc > -1) this.messages.splice(loc, 1)
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    leaveConfirmed: function () {
      this.$store.dispatch("setExecuting", true)
      api.post("/conversation/leave/" + this.currentMessage.id, {}).then(
        (results) => {
          this.leaveModal = false
          this.showList = true
          this.showMessage = false
          let loc = this.messages.indexOf(this.currentMessage)
          this.messages.splice(loc, 1)
          this.currentMessage = null
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
    ,
    inbox: function () {
      if (this.messages.length == 0) {
        //force reload without query parameters
        window.location = "/conversations"
        return
      }
      this.currentMessage = null
      this.showList = true
      this.showMessage = false
    }

  }
  ,
}
;
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
</style>
